export interface BossDefeatedActions {
  /** «Поделиться» после босса (S4/I5: картинка «I crushed N zombies», убийства знает бой). */
  share(info: { wave: number; kills?: number; target?: "chat" | "story" }): void;
}

const noop = () => {};

export const defaults: BossDefeatedActions = {
  share: noop,
};

declare module "../actions" {
  interface WindowActions extends BossDefeatedActions {}
}
